import { defineStore } from 'pinia';
import LogService from '@/service/LogService';

export const useLogStore = defineStore('useLogStore', {
  state: () => ({}),
  getters: {},
  actions: {
    async handleGetXml(payload) {
      const { quoteId } = payload;
      try {
        const logService = new LogService();
        return await logService.getLogXML(quoteId);
      } catch (error) {
        return {
          status: false,
          error: error?.message
        };
      }
    },

    async historyRuleLog(type: string, payload: any) {
      const logService = new LogService();
      const res = await logService.historyRuleLog(type, payload);
      return res?.data;
    }
  }
});
